<div class="link-creator-wrapper">
    <form [formGroup]="linkCreatorForm" (submit)="close(true)">
        <div class="inputWrapper">
            <label for="linkName">{{'wysiwyg.link_text' | translate}}</label>
            <input class="baseInput" name="linkName" formControlName="linkName" />
        </div>
        <div class="inputWrapper">
            <label for="linkUrl">{{'wysiwyg.link_url' | translate}}</label>
            <input class="baseInput" name="linkUrl" formControlName="linkUrl" placeholder="https://mysite.be" />
        </div>
    </form>

    <div class="submitButtons">


        <button matIconButton class="primary-button" [matTooltip]="'wysiwyg.add_link' | translate"  [ngClass]="{'highlight': highlightSaveButton}" aria-label="{{'wysiwyg.add_link' | translate}}" (click)="close(true)">
            <mat-icon>check</mat-icon>
        </button>

        <button matIconButton class="primary-button" [matTooltip]="'general.cancel' | translate" aria-label="{{'general.cancel' | translate}}" (click)="close(false)">
            <mat-icon>close</mat-icon>
        </button>

        @if(existingLink){
        <button matIconButton  class="primary-button"  aria-label="{{'wysiwyg.remove_link' | translate}}"  [matTooltip]="'wysiwyg.remove_link' | translate" (click)="removeLink()">
            <mat-icon>delete</mat-icon>
        </button>
        }

    </div>

</div>